import getyourguide from "@/assets/social/getyourguide.png";
import instagram from "@/assets/social/instagram.png";
import linkedin from "@/assets/social/linkedin.png";
import tripadvisor from "@/assets/social/tripadvisor.png";
import facebook from "@/assets/social/facebook.png";
import x from "@/assets/social/x.png";
import youtube from "@/assets/social/youtube.webp";

const socials = [
  { src: facebook, label: "Facebook profile", href: "#" },
  { src: instagram, label: "Instagram profile", href: "#" },
  { src: x, label: "X (Twitter) profile", href: "#" },
  { src: youtube, label: "YouTube channel", href: "#" },
  { src: linkedin, label: "LinkedIn profile", href: "#" },
  { src: tripadvisor, label: "Tripadvisor reviews", href: "#" },
  { src: getyourguide, label: "GetYourGuide listings", href: "#" },
];

const Footer = () => (
  <footer className="bg-ink text-background/85 py-14">
    <div className="container">
      <div className="flex flex-col md:flex-row justify-between gap-8 items-start">
        <div>
          <p className="font-display text-3xl text-background">Aṅkor Sojourns</p>
        </div>
        <div className="flex flex-wrap gap-8 text-[11px] uppercase tracking-[0.3em]">
          <a href="/tours" className="hover:text-gold transition-colors">Cambodia Tours</a>
          <a href="/#story" className="hover:text-gold transition-colors">Our Story</a>
          <a href="/#journal" className="hover:text-gold transition-colors">Journal</a>
          <a href="/#contact" className="hover:text-gold transition-colors">Contact</a>
          <a href="#" className="hover:text-gold transition-colors">Customer Reviews</a>
          <a href="/blog" className="hover:text-gold transition-colors">Blog</a>
          <a href="#" className="hover:text-gold transition-colors">About</a>
          <a href="#" className="hover:text-gold transition-colors">Privacy Policy</a>
        </div>
        <div className="flex flex-col gap-2">
          <p className="uppercase tracking-[0.3em] text-background text-base">Contact</p>
          <a href="mailto:ladongnan@gmail.com" className="hover:text-gold transition-colors text-base">ladongnan@gmail.com</a>
          <a href="tel:+85511944544" className="hover:text-gold transition-colors text-base">+855 11 944 544</a>
        </div>
      </div>
      <div className="divider-rule my-10 opacity-40" />
      <div className="flex flex-wrap items-center gap-5 mb-8">
        {socials.map((s) => (
          <a
            key={s.label}
            href={s.href}
            aria-label={s.label}
            className="inline-flex items-center justify-center h-11 w-11 overflow-hidden rounded-md bg-background/5 hover:opacity-80 transition-opacity"
          >
            <img src={s.src} alt="" aria-hidden="true" className="h-7 w-7 object-contain" loading="lazy" />
          </a>
        ))}
      </div>
      <p className="text-[11px] uppercase tracking-[0.25em] text-background/85">
        © {new Date().getFullYear()} Aṅkor Sojourns · 3% of every booking funds Angkor restoration
      </p>
    </div>
  </footer>
);
export default Footer;
